import { render, staticRenderFns } from "./solutionView.vue?vue&type=template&id=a2867b8c&"
import script from "./solutionView.vue?vue&type=script&lang=js&"
export * from "./solutionView.vue?vue&type=script&lang=js&"
import style0 from "./solutionView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports